const DATA = {
  tours: [
    {
      id: '1',
      currency: '$',
      name: 'Studio Tour',
      cancellationPolicyName: '7 days',
      cancellationPolicyText:
        'To redeem the gift certificate, the recipients can simply use the included promotion code to book their tour online on Warner Bros. Studio Tour Hollywood website. \n Timeslots are subject to availability and all minors attending the Studio Tour must be accompanied by an adult.',
      image:
        'https://s3-us-west-1.amazonaws.com/anyroad-public-assets/images/warner_brothers_demo/studio_tour.jpg',
      description:
        'Experience one of the busiest movie studios in LA as you explore our iconic backlots, DC Universe: The Exhibit, and original Batmobiles. Plus, you’ll view one of our many soundstages where today’s hottest TV shows and movies are made. With actual filming happening all around you, no two Warner Bros. tours are ever alike. \nStudio Tours run about 2-hours for the guided portion, as well as a self guided visit to Stage 48: Script-to-Screen. We anticipate the entire experience to last approximately 3 hours.',
      pricing: {
        base_price: '$65',
        types: [
          {
            id: 1,
            name: 'Adults',
            description: 'Guests 12 and over',
            price: '65',
          },
          {
            id: 2,
            name: 'Children',
            description: 'Ages 8 - 12',
            price: '55',
          },
        ],
      },
    },
    {
      id: '2',
      currency: '$',
      name: 'Deluxe Tour',
      cancellationPolicyName: '7 days',
      cancellationPolicyText:
        'To redeem the gift certificate, the recipients can simply use the included promotion code to book their tour online on Warner Bros. Studio Tour Hollywood website. \n Timeslots are subject to availability and all minors attending the Studio Tour must be accompanied by an adult.',
      image:
        'https://s3-us-west-1.amazonaws.com/anyroad-public-assets/images/warner_brothers_demo/deluxe_tour.jpg',
      description:
        "Enjoy the ultimate Hollywood experience with our five-hour Deluxe Tour.  This tour is specially designed for our biggest film and TV fans.  You'll walk in the footsteps of Hollywood royalty guided by one of our expert tour guides, who will give you an in-depth look behind-the-lens of how TV and movie magic is brought to life on screen. \nYour Deluxe Tour includes all elements of the Studio Tour plus visits to Post Production, the Costume Department, the Property Department and Warner Bros. Commissary Fine Dining Room for an exquisite lunch.",
      pricing: {
        base_price: '$295',
        types: [
          {
            id: 1,
            name: 'Guests',
            description: '',
            price: '295',
          },
        ],
      },
    },
  ],
};

export default DATA;
